/** The collab tracking page. */
export const COLLAB_TRACKING_PATH = '/collabs/suivi';

/**
 * The tracking list opened on one collab, which `useCollabDeepLink` turns into
 * the collab's own panel. The one address every surface sends a brand to.
 */
export const collabTrackingHref = (collabId: string): string =>
  `${COLLAB_TRACKING_PATH}?collab=${encodeURIComponent(collabId)}`;
